export const apiErrorDetail = (error: unknown, fallback: string): string => {
  const response = (error as { response?: { status?: number; data?: { detail?: unknown } } })?.response
  const detail = response?.data?.detail
  return response?.status === 409 && typeof detail === 'string' && detail ? detail : fallback
}
